var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('ActionBar',{attrs:{"breadcrumbItems":_vm.breadcrumbItems}},[_vm._v(" actions ")]),_c('div',{staticClass:"page--content"},[_vm._v(" RevenuesPage ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }